import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CsvDownloadComponent from '../widgets/csvDownload/CsvDownloadComponent';
import PieChartComponent from './PieChartComponent';
import BarChartComponent from './BarChartComponent';
import { useModal } from '../../hooks/useModal';
import DynamicTable from '../widgets/dynamicTable/DynamicTable';
import { Button, Form } from 'react-bootstrap';
import Pie2LevelsChartComponent from './Pie2LevelsChartComponent';
import ChronogramComponent from '../producerStats/ChronogramComponent';
import Loader from '../widgets/Loader';

const ChartComponent = ({ title, tableCsv, csvSort, indexTable, csvFilename, graphType, data = [],
    dataNamesLabel, parentsDataNamesLabel, dataValuesLabel, secondDataValuesLabel, legendNames,
    isDataAvailable, legendNewlabels, toggleButton, isFetching = false, aggregatable = false, aggregate, setAggregate, itemLabel }) => {
    const [downloadCSV, setDownloadCSV] = useState(false);

    const { modalComponent, setModalShow, modalData, setModalData } = useModal();

    const displayGeneralRanking = () => {
        setModalData({
            ...modalData,
            header: <>Classement général {title?.replace("Top 5 ", "")}</>,
            content: <DynamicTable
                contentTable={tableCsv}
                contentSort={csvSort}
                valueInitSort="count"
                index={indexTable}
                filename={"classement_general_" + csvFilename}
            />,
            cancelButton: 'OK',
            size: 'lg'
        });
        setModalShow(true);
    }

    const graphComponent = {
        pie: <PieChartComponent
            key={csvFilename}
            data={data}
            dataNamesLabel={dataNamesLabel}
            dataValuesLabel={dataValuesLabel}
            isDataAvailable={isDataAvailable}
            legendNewlabels={legendNewlabels}
        />,
        pie2Levels: <Pie2LevelsChartComponent
            key={csvFilename}
            data={data}
            dataNamesLabel={dataNamesLabel}
            dataValuesLabel={dataValuesLabel}
            dataParentsLabel={parentsDataNamesLabel}
            isDataAvailable={isDataAvailable}
            legendNewlabels={legendNewlabels}
        />,
        bar: <BarChartComponent
            key={csvFilename}
            data={data}
            dataNamesLabel={dataNamesLabel}
            dataValuesLabel={dataValuesLabel}
            isDataAvailable={isDataAvailable}
            secondDataValuesLabel={secondDataValuesLabel}
            legendNames={legendNames}
        />,
        barTop5: <BarChartComponent
            key={csvFilename}
            data={data}
            dataNamesLabel={dataNamesLabel}
            dataValuesLabel={dataValuesLabel}
            isDataAvailable={isDataAvailable}
            secondDataValuesLabel={secondDataValuesLabel}
            legendNames={legendNames}
        />,
        chronogram: <ChronogramComponent
            data={data}
            aggregated={aggregate}
            itemLabel={itemLabel}
            dataValuesLabel={dataValuesLabel}
        />
    };

    const downloadableBtn = downloadCSV
        ? <CsvDownloadComponent
            contentTable={tableCsv}
            contentSort={csvSort}
            setDownloadCSV={setDownloadCSV}
            filename={csvFilename}
        />
        : <div onClick={() => setDownloadCSV(true)} type="button" role="button">
            <i className="fas fa-download mr-2" /><span className='text-decoration-underline'>Télécharger en csv</span>
        </div>;

    return data && <div>
        <div className='d-flex justify-content-between align-items-center'>
            {data?.length
                ? downloadableBtn
                : <>&nbsp;</>}
                {<div className="mb-2">
                    {toggleButton ?? <div className='mt-5'></div>}
                </div>}
        </div>
        <div className='d-flex flex-column align-items-center bg-white'>
            <h4 className='mt-3 text-center'>{title}</h4>
            {aggregatable &&
                <Form.Check id={"aggregate_" + csvFilename} className="clickable mb-3 ms-3" label="Agréger les données"
                    defaultChecked={aggregate} onChange={() => setAggregate((prev) => !prev)} />}
            {isFetching
                ? <Loader />
                : graphComponent[graphType]}

            {graphType === "barTop5" && tableCsv?.length > 5
                && <Button variant='light' onClick={displayGeneralRanking} className='my-3'>
                    Voir le classement général
                </Button>}
            {modalComponent}
        </div>
    </div>;
}

ChartComponent.propTypes = {
    title: PropTypes.string.isRequired,
    csvFilename: PropTypes.string.isRequired,
    tableCsv: PropTypes.array.isRequired,
    csvSort: PropTypes.array.isRequired,
    indexTable: PropTypes.string,
    graphType: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    dataNamesLabel: PropTypes.string.isRequired,
    dataValuesLabel: PropTypes.string.isRequired,
    secondDataValuesLabel: PropTypes.string,
    parentsDataNamesLabel: PropTypes.string,
    legendNames: PropTypes.object,
    isDataAvailable: PropTypes.bool.isRequired,
    legendNewlabels: PropTypes.object,
    toggleButton: PropTypes.object,
    isFetching: PropTypes.bool,
    aggregate: PropTypes.bool,
    itemLabel: PropTypes.string,
    aggregate: PropTypes.bool,
    setAggregate: PropTypes.func
};

export default ChartComponent;